import { wrap as withStyle } from 'utils/styles'

export default withStyle((_) => {
  return `
    overflow-y: auto;
    height: 100%;
  `
})
